import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { NavigationContext } from './NavigationContext';

export const NavigationProvider = ({ children }: PropsWithChildren) => {
  const [stack, setStack] = useState<string[]>([]);

  return <NavigationContext.Provider value={{ stack, setStack }}>{children}</NavigationContext.Provider>;
};
